import { render, staticRenderFns } from "./ValidationRegistration.vue?vue&type=template&id=338faaaf&scoped=true"
import script from "./ValidationRegistration.vue?vue&type=script&lang=js"
export * from "./ValidationRegistration.vue?vue&type=script&lang=js"
import style0 from "./ValidationRegistration.vue?vue&type=style&index=0&id=338faaaf&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "338faaaf",
  null
  
)

export default component.exports